
const merge = (template: string, valueMap: any = {}): string => {
    Object.keys(valueMap).forEach(key => {
        template = template.replace('$' + key, valueMap[key]);
    })

    return template
}

export { merge }